import React from 'react';

import {
  Breadcrumb,
  Helmet,
  Sidebar,
  SidebarPage,
  SidebarPageContainer,
} from 'fr-shared/components';
import { useTableFilters } from 'fr-shared/hooks';

import CostingSearch from './components/CostingSearch';
import CostingSidebar from './components/CostingSidebar';
import CostingTable from './components/CostingTable';
import {
  FILTER_FIELDS,
  INITIAL_IN_PROGRESS_FILTERS,
  INITIAL_IN_PROGRESS_SORT,
  IN_PROGRESS_COLUMNS,
  getInProgressCostingRequests,
} from './utils/queues';

const FILTER_NAME = 'costing_in_progress';
const FIELDS = [
  FILTER_FIELDS.SalesContactId,
  FILTER_FIELDS.ManufacturingProcessId,
  FILTER_FIELDS.EngineeringContactId,
  FILTER_FIELDS.SupportContactId,
];

const CostingInProgressQueue = () => {
  const {
    data: costingRequests,
    filters,
    loading,
    handleSearch: handleTextSearch,
    onFetchData: handleTableFetchData,
    pages,
    resetFilters,
    setFilters,
  } = useTableFilters(FILTER_NAME, INITIAL_IN_PROGRESS_FILTERS, getInProgressCostingRequests);

  return (
    <>
      <Helmet title="In Progress Queue" />
      <Breadcrumb to="/admin/costing_requests">Costing Requests</Breadcrumb>
      <Breadcrumb to="/admin/costing_requests/requested_queue">In Progress Queue</Breadcrumb>

      <SidebarPageContainer localStorageKey={Sidebar.LOCAL_STORAGE_KEYS.costing_in_progress}>
        <SidebarPage>
          <div className="page-header flex mb-0 px-3">
            <h2>In Progress Queue</h2>
            <CostingSearch
              filters={filters}
              setFilters={setFilters}
              onTextSearch={handleTextSearch}
            />
          </div>

          <CostingTable
            columns={IN_PROGRESS_COLUMNS}
            data={costingRequests}
            emptyText="No Requests are currently in progress"
            loading={loading}
            onFetchData={handleTableFetchData}
            pages={pages}
            sort={INITIAL_IN_PROGRESS_SORT}
          />
        </SidebarPage>

        <Sidebar>
          <CostingSidebar
            fields={FIELDS}
            filters={filters}
            resetFilters={resetFilters}
            setFilters={setFilters}
          />
        </Sidebar>
      </SidebarPageContainer>
    </>
  );
};

export default CostingInProgressQueue;
